module.exports = __webpack_public_path__ + "static/media/Formosa.5dd3903d.svg";